import isPDFPreviewSupported from 'owa-attachment-model-store/lib/utils/isPDFPreviewSupported';
import { getExtensionFromFileName, isImageFile } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { isDownloadAllowed } from './isDownloadAllowed';

export function isPrintAllowed(attachment: AttachmentType) {
    const fileExtension = getExtensionFromFileName(attachment.Name);
    const allowDownload = isDownloadAllowed(attachment);
    return (
        allowDownload &&
        fileExtension &&
        ((fileExtension.toLowerCase() === '.pdf' && isPDFPreviewSupported()) ||
            isImageFile(attachment.Name))
    );
}
